.card {
  padding: var(--pad);
  background: var(--surface);
  border: 1px solid var(--card-border);
  border-radius: var(--r-lg);
}

.flags {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
}

.title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
}

.bolt {
  display: flex;
  color: var(--warn);
}

/* Внутри карточки-героя: без своей подложки, отделено линией сверху —
   как продолжение коробки, а не отдельный блок. */
.embedded {
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid var(--hero-line);
}
